module.exports = __webpack_public_path__ + "img/bgimg.6df05571.png";